import styled from "styled-components"

import  Buttons from '../../buttons.jsx';
import api from '../../../axios.js';
import AutoSelect from '../autoSelect.jsx';
import { useState,useEffect } from "react"
import { useSelector } from 'react-redux';
import { estadoUsuario,newUsuario,usuarioSelected } from '../../../redux/actions/usuarioActions.js';
import  { useDispatch } from 'react-redux';
import BasicInfoUser from "./basicInfoUser.jsx"
import DetailInfoUser from "./detailInfoUser.jsx"
import SubPanel from "../subPanel.jsx"
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import UsersReport from'./usersReport.jsx'




const Container=styled.div`
	background-color:black;
	height:100%;
 `;

const ContainerOptions=styled.div`
	display:flex;
	justify-content:space-around;
	background: rgb(0,0,0);
	background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(38,37,37,1) 35%, rgba(0,0,0,1) 100%);
	justify-content:space-around;
	align-items:center;
	min-height:60px;
	height:9vh;
	position:relative
  `;

const ContainerButtons=styled.div`
 `;

const ContainerReport=styled.div`
	height:82vh;
	display:flex;
	justify-content:center;
	overflow:scroll;
	&::-webkit-scrollbar{
		background-color:transparent;
		width:3px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}

`;

const ContainerToggle=styled.div`
	position:absolute;
	left:15px

`;

const ContainerEdicion=styled.div`
	display:flex;
	flex-direction:column;
	justify-content:space-around;
	align-items:center;
	box-Shadow:0 10px 20px 5px rgba(0,0,0,0.2); 
	height:83vh;
	overflow:scroll;
	&::-webkit-scrollbar{
		background-color:transparent;
		width:3px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}
  `;


const ContainerAutoSelect=styled.div`
	width:50vw;
	min-width:670px;
	display:flex;
	justify-content:center;
 `;




 export default function UsuariosAdmin(){

 	let urlBack=process.env.REACT_APP_URL_API;
 	let [usuariosName,setUsuariosName]=useState();
 	let [usuarioVacio,setUsuarioVacio,]=useState(true);
 	let usuarioSelectedRedux=useSelector(state=>state.usuario.usuarioSelected);
 	let [usuarioData,setUsuarioData]=useState({id:"",name:"",usuario:"",password:"",tipo:""});
 	let usuarios=useSelector(state=>state.usuario.usuarios);
 	let estado=useSelector(state=>state.usuario.estadoUsuario);	
	let nuevoUsuario=useSelector(state=>state.usuario.newUsuario);
	let base={ name:"",usuario:"",password:"",tipo:0 };
	let dispatch=useDispatch()
	let [tipo,setTipo]=useState("reporte");
	

	let paisSelected=(event,newvalue)=>{
		dispatch(newUsuario({pais:newvalue.label}));
		dispatch(newUsuario({codPais:newvalue.phone}));
	};

	const handleChange = (event, newTipo) => {
    		setTipo(newTipo);
  	};

	useEffect(()=>{
 		if(estado===0){ 			
 	 			let nombres=[];
 	 			usuarios.map(ele=>ele.isActivate?nombres.push({label:`${ele.name}`,value:ele}):null) 	
 	 			console.log(nombres);
 	 			console.log(usuarios); 	
 	 			setUsuariosName(nombres); 	 			
 		}
 	},[urlBack,usuarios,estado]);


 	useEffect(()=>{
 		usuarioSelectedRedux.name?setUsuarioVacio(false):setUsuarioVacio(true);
 	},[usuarioSelectedRedux]);
 	
 	useEffect(()=>{
 		let getData=async()=>{
 			let rsp = await api.get(`/usuario?id=${usuarioSelectedRedux.id}`);
 		setUsuarioData(rsp.data)
 		};

 		getData();
 		
 		

 	},[usuarioSelectedRedux]);
 	



 	return(
 		<Container>  
 			
 			<ContainerOptions>
 				<ContainerToggle>
 					<ToggleButtonGroup size="small" exclusive value={tipo}  onChange={handleChange}>
 			  		<ToggleButton value="reporte">Reporte</ToggleButton>
      				<ToggleButton value="creacion">Creacion</ToggleButton>
    			</ToggleButtonGroup> 					
 			</ContainerToggle>
 				

 				
 				<ContainerAutoSelect>
 					{tipo==="creacion"?
 						<AutoSelect data={usuariosName}  id="usuario"    label="usuarios"  disabled={estado!==0?true:false} action={usuarioSelected} />:
 						null}
 				</ContainerAutoSelect>

 				<ContainerButtons >
 					{tipo==="creacion"?<Buttons 
 						estado={estado}
 						alterEstado={estadoUsuario} 
 						empty={usuarioVacio} 
 						action={newUsuario} 
 						estadoBase={base} 
 						dataSave={estado===2?{...nuevoUsuario,
 										id:usuarioSelectedRedux.id}
 										:{...nuevoUsuario,telefono:`${nuevoUsuario.codPais} ${nuevoUsuario.telefono}`} }
 						url={`/usuario`} 
 						reloadAction={usuarioSelected({id:"",name:"",usuario:"",password:"",tipo:"",correo:"",telefono:"",pais:"",prefijo:""})}
 						idDelete={usuarioSelectedRedux.id}
 					/>:null	}
 				</ContainerButtons>
 			</ContainerOptions>
 			{tipo==="reporte"?
 				<ContainerReport>
 					<UsersReport usuarios={usuarios}  />
 				</ContainerReport>:
 				<ContainerEdicion>
 					<SubPanel child={<BasicInfoUser value={estado===1?nuevoUsuario:usuarioData} action={newUsuario} estado={estado}/>} />
 					<SubPanel child={<DetailInfoUser value={estado===1?nuevoUsuario:usuarioData} action={newUsuario} estado={estado} url={`${urlBack}/usuario`}  paisSelected={paisSelected}/>} />
 				</ContainerEdicion>
 			}
 			
 		</Container>


 		)
 }